import bus from "@/plugin/bus";
import Vue from "vue";

let vm = new Vue({
    data() {
        return {
            queue: []
        };
    }
});
let queue = [];

vm.$watch("queue", function(newVal, oldVal) {
    // 暂时还没有这个需求
    // if(vm.queue.length != 0){
    //     bus.$emit(`APP_REQUESTING`, vm.queue)
    // }

    if (vm.queue.length == 0) {
        bus.$emit(`APP_REQUEST_FINISH`);
    }
});
function push(name) {
    vm.queue.push(name);
    bus.$emit(`${name}`, { status: "start" });
}
function remove(name, data) {
    var index = vm.queue.indexOf(name);
    vm.queue.splice(index, 1);
    bus.$emit(`${name}`, { status: "success", data: data });

    if (data.ec == 40101 || data.ec == 40100) { //40101 token过期， 40100未登录
        bus.$emit(`SESSION_EXPIRED`, { data: data });
    }
    if (data.ec == 40102) {
        bus.$emit(`NEED_BIND`, { data: data });
    }
}
// function push(name) {
//     queue.push(name)
//     bus.$emit(`${name}`, {status:'start'})
// }
// function remove(name, data) {
//     var index = queue.indexOf(name)
//     queue.splice(index,1)
//     bus.$emit(`${name}`, {status:'success', data: data})
//
//     if(data.ec == 40101){
//         bus.$emit(`SESSION_EXPIRED`, {data: data})
//     }
// }
export default {
    push,
    remove,
    queue: vm.queue
};
